// @flow
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from "@material-ui/core/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => ({
    input: {
        margin: 0,
        marginRight: theme.spacing(2)
    },
}));

export type Props = $ReadOnly<{
    onChange: (value: string) => string
}>;

function SearchForm({ onChange }: Props) {
    const classes = useStyles();
    const [query, setQuery] = useState();

    const handleChange = (e) => {
        setQuery(e.target.value);
        onChange(e.target.value);
    };

    return (
        <Box display="flex">
            <TextField
                label={<FormattedMessage
                    id="alerts.filter"
                    defaultMessage="Filter"
                />}
                classes={{ root: classes.input}}
                fullWidth
                variant="filled"
                margin="dense"
                value={query || ''}
                onChange={handleChange}
            />
            <Button size="large" type="submit" color="primary" variant="contained">
                <FormattedMessage
                    id="alerts.find"
                    defaultMessage="Find"
                />
            </Button>
        </Box>
    );
}

export default SearchForm;